import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import {
  mdmInstalledApplicationsFeatureKey,
  mdmInstalledApplicationsReducer,
} from './mdm-installed-applications.reducer';
import { EffectsModule } from '@ngrx/effects';
import { MdmInstalledApplicationsEffects } from './mdm-installed-applications.effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(mdmInstalledApplicationsFeatureKey, mdmInstalledApplicationsReducer),
    EffectsModule.forFeature([MdmInstalledApplicationsEffects]),
  ],
  providers: [],
})
export class MdmInstalledApplicationsStoreModule {}
